import React from "react";

const IntegrationStatusLogo = ({ src }) => (
  <div className="integration-status-logo">
    <img src={src} alt="" />
  </div>
);

export default IntegrationStatusLogo;
